import React from 'react';
import PropTypes from 'prop-types';

const Close = ({ color = '#CBCED0' }) => (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/10px-(All-icons)/no-scale/close-10px"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M5,4.29289322 L8.24644661,1.04644661 C8.44170876,0.851184464 8.75829124,0.851184464 8.95355339,1.04644661 C9.14881554,1.24170876 9.14881554,1.55829124 8.95355339,1.75355339 L5.70710678,5 L8.95355339,8.24644661 C9.14881554,8.44170876 9.14881554,8.75829124 8.95355339,8.95355339 C8.75829124,9.14881554 8.44170876,9.14881554 8.24644661,8.95355339 L5,5.70710678 L1.75355339,8.95355339 C1.55829124,9.14881554 1.24170876,9.14881554 1.04644661,8.95355339 C0.851184464,8.75829124 0.851184464,8.44170876 1.04644661,8.24644661 L4.29289322,5 L1.04644661,1.75355339 C0.851184464,1.55829124 0.851184464,1.24170876 1.04644661,1.04644661 C1.24170876,0.851184464 1.55829124,0.851184464 1.75355339,1.04644661 L5,4.29289322 Z"
                id="Mask"
                fill={color}
                fillRule="nonzero"
                className="icon-color"
            />
        </g>
    </svg>
);

Close.propTypes = {
    color: PropTypes.string,
};

export default Close;
